import React from "react";
import {
  allowAccess,
  getUserProfileStatus,
  haveAccessToFeature,
  isMasterMerchant,
  isRoleCashier,
  isMultiEntityUser,
  isUnverifiedMerchantUser,
  hideDashboardPage,
  hideInsightPage,
  isDraftUser,
  hideOrderPage,
  allowEmployeeManagementPage,
  hideMarketingPage,
} from "../../utils";
import {
  ADMIN_KEY,
  HELP_CENTRE_KEY,
  FINANCES_KEY,
  INSIGHTS_KEY,
  ORDER_KEY,
  FEEDBACK_KEY,
  MENU_KEY,
  UMP_KEY,
  hasAccessMenu,
  hasAccessUMP,
  PROFILE_STATUS_DRAFT,
  INVENTORY_KEY,
  hasAccessInventory,
  PAYNOW_KEY,
  hasAccessPayNow,
  LS_IS_PAYNOW_QR_VISITED,
  HOME_KEY,
  hasAccessOrderManager,
  hasAccessFeedback,
} from "../../constants";
import { InventoryIconV2 } from "../../assets/icons/inventory-icon-v2";
import { InventoryIconV2Selected } from "../../assets/icons/inventory-icon-v2-selected";
import I18n from "i18n-js";
import {
  HomeOutlined,
  HomeFilled,
  InsightOutlined,
  InsightFilled,
  OrdersOutlined,
  OrdersFilled,
  ChatOutlined,
  ChatFilled,
  CreditCardOutlined,
  CreditCardFilled,
  MegaphoneOutlined,
  MegaphoneFilled,
  UserGroupOutlined,
  UserGroupFilled,
  HelpOutlined,
  HelpFilled,
  QrCodeScannerUniversal,
  MenuBookUniversal,
} from "@duxton-web/icons";
import { Badge } from "@duxton-web/ui";
import {
  getModuleNameByKey,
  hasPermission,
  isTabEnabledForVE,
  isUserPermissionSystemActive,
  PERMISSION_ACTION,
} from "@mex/mex-permissions-lib";

export default (collapsed = false) => {
  const canAccessPayNowQR =
    haveAccessToFeature(hasAccessPayNow) && allowAccess();
  const showPayNowQRNewIcon = !Boolean(
    localStorage.getItem(LS_IS_PAYNOW_QR_VISITED),
  );
  const isCashier = isRoleCashier();
  const isMEUser = isMultiEntityUser();
  const isUMUser = isUnverifiedMerchantUser();
  const isUMPNonMexUser =
    haveAccessToFeature(hasAccessUMP) &&
    getUserProfileStatus() === PROFILE_STATUS_DRAFT;

  const menusForMexUsers = [
    {
      key: HOME_KEY,
      testId: "homeButton",
      icon: <HomeOutlined />,
      iconSelected: <HomeFilled />,
      title: I18n.t("troyCommon-navigation-home"),
      show: !hideDashboardPage() && !isUMUser && isTabEnabledForVE(HOME_KEY),
    },
    {
      key: INSIGHTS_KEY,
      testId: "insightButton",
      icon: <InsightOutlined />,
      iconSelected: <InsightFilled />,
      title: I18n.t("troyCommon-navigation-001-002"),
      show:
        !hideInsightPage() &&
        !isMasterMerchant() &&
        !isUMUser &&
        isTabEnabledForVE(INSIGHTS_KEY),
      label: (
        <Badge
          dot={collapsed}
          className="menu-label-red"
          count={I18n.t("mex-insightsv2-001-009-label")}
        />
      ),
    },
    {
      key: ORDER_KEY,
      testId: "orderButton",
      icon: <OrdersOutlined />,
      iconSelected: <OrdersFilled />,
      title: I18n.t("troyCommon-navigation-002-001"),
      show:
        haveAccessToFeature(hasAccessOrderManager) &&
        !isMEUser &&
        !hideOrderPage() &&
        !isUMUser &&
        isTabEnabledForVE(ORDER_KEY),
    },
    {
      key: FEEDBACK_KEY,
      testId: "feedbackButton",
      icon: <ChatOutlined />,
      iconSelected: <ChatFilled />,
      title: I18n.t("troy-mexreviews-portal-001-001-menu"),
      show:
        haveAccessToFeature(hasAccessFeedback) &&
        !isMEUser &&
        !isUMUser &&
        isTabEnabledForVE(FEEDBACK_KEY),
    },
    {
      key: FINANCES_KEY,
      testId: "financeButton",
      icon: <CreditCardOutlined />,
      iconSelected: <CreditCardFilled />,
      title: I18n.t("troyCommon-navigation-001-001"),
      show:
        hasPermission({
          action: PERMISSION_ACTION.GET,
          module: getModuleNameByKey("finance"),
          legacyPermissionCheck: () => !isCashier,
        }) &&
        !isDraftUser() &&
        !isUMUser &&
        isTabEnabledForVE(FINANCES_KEY),
      label: (
        <Badge
          dot={collapsed}
          className="menu-label-red"
          count={I18n.t("mex-insightsv2-001-009-label")}
        />
      ),
    },
    {
      key: UMP_KEY,
      testId: "marketingButton",
      icon: <MegaphoneOutlined />,
      iconSelected: <MegaphoneFilled />,
      title: I18n.t("troy-mex-businessinsights-001-005-tab"),
      show:
        !isCashier &&
        !hideMarketingPage() &&
        isTabEnabledForVE(UMP_KEY) &&
        hasPermission({
          action: PERMISSION_ACTION.GET,
          module: getModuleNameByKey("marketing"),
          legacyPermissionCheck: () => !isCashier && !hideMarketingPage(),
        }),
      label: (
        <Badge
          dot={collapsed}
          className="menu-label-red"
          count={I18n.t("mex-insightsv2-001-009-label")}
        />
      ),
    },
    {
      key: MENU_KEY,
      testId: "menuButton",
      icon: <MenuBookUniversal />,
      iconSelected: <MenuBookUniversal />,
      title: I18n.t("troy-mex-businessinsights-001-004-tab"),
      show:
        hasPermission({
          action: PERMISSION_ACTION.GET,
          module: getModuleNameByKey("menu"),
          legacyPermissionCheck: () => !isCashier,
        }) &&
        haveAccessToFeature(hasAccessMenu) &&
        !isMEUser &&
        !isUMUser &&
        isTabEnabledForVE(MENU_KEY),
    },
    {
      key: INVENTORY_KEY,
      icon: <InventoryIconV2 />,
      iconSelected: <InventoryIconV2Selected />,
      title: I18n.t("troy-inventorytab-001-001-body"),
      show:
        haveAccessToFeature(hasAccessInventory) &&
        !isCashier &&
        !isMEUser &&
        !isUMUser &&
        isTabEnabledForVE(INVENTORY_KEY),
    },
    {
      key: ADMIN_KEY,
      testId: "employeesButton",
      icon: <UserGroupOutlined />,
      iconSelected: <UserGroupFilled />,
      title: I18n.t("troyCommon-navigation-001-003"),
      show:
        isTabEnabledForVE(ADMIN_KEY) && isUserPermissionSystemActive()
          ? hasPermission({
              action: PERMISSION_ACTION.GET,
              module: getModuleNameByKey("employee_management/employee"),
              legacyPermissionCheck: () =>
                allowAccess() && allowEmployeeManagementPage(),
            })
          : allowAccess() && allowEmployeeManagementPage(),
    },
    {
      key: PAYNOW_KEY,
      icon: <QrCodeScannerUniversal />,
      iconSelected: <QrCodeScannerUniversal />,
      title: "PayNow QR",
      show: isTabEnabledForVE(PAYNOW_KEY) && canAccessPayNowQR && !isUMUser,
      label: showPayNowQRNewIcon && (
        <Badge
          dot={collapsed}
          className="menu-label-red"
          count={I18n.t("mex-insightsv2-001-009-label")}
        />
      ),
    },
    {
      key: HELP_CENTRE_KEY,
      testId: "helpCenterButton",
      icon: <HelpOutlined />,
      iconSelected: <HelpFilled />,
      title: I18n.t("troyCommon-navigation-001-005"),
      show: true,
    },
  ];

  const menusForUMPNonMexUsers = [
    {
      key: UMP_KEY,
      testId: "marketingButton",
      icon: <MegaphoneOutlined />,
      iconSelected: <MegaphoneFilled />,
      title: I18n.t("troy-mex-businessinsights-001-005-tab"),
      // non-mex still only open for whitelisetd users for now.
      show:
        !isMEUser &&
        haveAccessToFeature(hasAccessUMP) &&
        isTabEnabledForVE(UMP_KEY),
    },
    {
      key: HELP_CENTRE_KEY,
      testId: "helpCenterButton",
      icon: <HelpOutlined />,
      iconSelected: <HelpFilled />,
      title: I18n.t("troyCommon-navigation-001-005"),
      show: true,
    },
  ];

  // Hide the all merchant related menus for non-mex and UMP users
  return isUMPNonMexUser ? menusForUMPNonMexUsers : menusForMexUsers;
};
